import { render } from "./MdSvgLoader.vue?vue&type=template&id=571cbd5d"
import script from "./MdSvgLoader.vue?vue&type=script&lang=js"
export * from "./MdSvgLoader.vue?vue&type=script&lang=js"

import "./MdSvgLoader.vue?vue&type=style&index=0&id=571cbd5d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__